import _ from 'lodash';
import moment from 'moment';
import api from '@/utils/api';
import XLSX_STYLE from 'xlsx-js-style';
import ExportExcelTemplate from './ExportExcelTemplate';

// 取得資料
export async function fetchRowDatas({
    StartDate, EndDate, AccountStart, AccountEnd,
}) {
    const queryParams = {
        AccountStart,
        AccountEnd,
        QueryType: 1,
        StartDate,
        EndDate,
    };

    try {
        const resp = await api({
            url: '/AccountingSummaryReport/QueryAccountBalance',
            method: 'GET',
            params: queryParams,
        });

        return _.sortBy(resp.data.items, 'accno');
    } catch (ex) {
        console.log(ex);
        return [];
    }
}

// 將API資料整理成 excel 的資料
export function formatDataRows(rawDatas) {
    const rows = [];
    rawDatas.forEach((item) => {
        rows.push([
            item.accno,
            item.accnam,
            item.dC_TYP === 1 ? '借' : '貸',
            item.dC_TYP === 1 ? item.exTotalAmount : 0,
            item.dC_TYP === 2 ? item.exTotalAmount : 0,
            item.crD_NTD,
            item.deB_NTD,
            item.dC_TYP === 1 ? item.exTotalAmount + item.totalAmount : 0,
            item.dC_TYP === 2 ? item.exTotalAmount + item.totalAmount : 0,
        ]);
    });
    return rows;
}

// 建立 Excel 工作表
export function createExcelSheet({ StartDate, EndDate }, rawDatas, companyName) {
    const rows = formatDataRows(rawDatas);
    const sheet = _.cloneDeep(ExportExcelTemplate);

    XLSX_STYLE.utils.sheet_add_aoa(sheet, rows, { origin: 'A4' });

    const widthSettings = [12, 20, 12, 20, 20, 20, 20, 20, 20];
    // 設定全部欄寬 (由bodyHeader定義，預設 15)
    sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));
    sheet['!rows'] = [{ hpx: 70 }, { hpx: 25 }];

    _.forEach(sheet, (value, key) => {
        if (!key.includes('!')) {
            // 'B13' => COL: 'B', ROW: '13'
            const isLetterSingle = !Number.isNaN(Number(key.substring(1)));
            const COL = isLetterSingle ? key.substring(0, 1) : key.substring(0, 2);
            const ROW = isLetterSingle ? Number(key.substring(1)) : Number(key.substring(2));

            // 每一格
            sheet[key].s = {
                alignment: {
                    horizontal: 'left',
                    vertical: 'bottom',
                },
            };

            // 公司名稱標題
            if (key === 'A1') {
                sheet[key].s.alignment.horizontal = 'center';
                sheet[key].s.alignment.vertical = 'center';
                sheet[key].s.alignment.wrapText = true;

                sheet[key].v = `${companyName}\n會計科目餘額試算表`;

                sheet[key].s.font = { bold: true, sz: 16 };
            }

            // 選取區間
            if (key === 'A2') {
                sheet[key].s.alignment.horizontal = 'left';
                sheet[key].s.alignment.vertical = 'center';

                const START_DATE = moment(+StartDate);
                const END_DATE = moment(+EndDate);
                sheet[key].v = `傳票日期範圍：${START_DATE.year() - 1911}-${START_DATE.format('MM-DD')} 至 ${END_DATE.year() - 1911}-${END_DATE.format('MM-DD')}`;
            }

            // 製表日期
            if (key === 'H2') {
                sheet[key].s.alignment.horizontal = 'right';
                sheet[key].s.alignment.vertical = 'center';
                const TODAY = moment();
                sheet[key].v = `製表日期：${TODAY.year() - 1911}-${TODAY.format('MM-DD')}`;
            }

            // 借、貸方金額格式設定
            if (!(COL === 'A' || COL === 'B' || COL === 'C')) {
                sheet[key].s.alignment.horizontal = 'right';
                sheet[key].z = '#,##0_-;-#,##0_-;0;General';
            }

            // 表頭字體設定
            if (ROW === 3) sheet[key].s.font = { bold: true };

            // 表頭 ＆ 之後得每一列資料
            if (ROW >= 3) {
                sheet[key].s.border = {
                    bottom: { style: 'thin', color: 'FFFFFFFF' },
                    top: { style: 'thin', color: 'FFFFFFFF' },
                    left: { style: 'thin', color: 'FFFFFFFF' },
                    right: { style: 'thin', color: 'FFFFFFFF' },
                };
            }
        }
    });

    return sheet;
}

// 下載 Excel
export async function downloadExcel(queryParams, companyName, rawDatas = null, directDownload = true) {
    const datas = rawDatas || (await fetchRowDatas(queryParams)); // 如果沒有給資料，就重新拿一份
    const excelBook = XLSX_STYLE.utils.book_new();
    const excelSheet = createExcelSheet(queryParams, datas, companyName);
    const fileName = `${moment(+queryParams.StartDate).format('YYYY-MM-DD')}～${moment(+queryParams.EndDate).format('YYYY-MM-DD')}會計科目餘額試算表.xlsx`;

    XLSX_STYLE.utils.book_append_sheet(excelBook, excelSheet, '會計科目餘額試算表');

    if (directDownload) {
        return XLSX_STYLE.writeFile(excelBook, fileName);
    }
    const excelBuffer = XLSX_STYLE.write(excelBook, { type: 'array', bookType: 'xlsx' });
    return { buffer: excelBuffer, fileName };
}
